<template >
    <span>
    <v-toolbar
      v-if="this.$session.exists()"
      class="grey darken-4 header__bar"
      dark
      absolute
      style="position:fixed"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"/>
      <v-flex text-center>
        <v-toolbar-title
          text-center
          style="cursor:pointer"
          @click="$router.push('/')"
          class="white--text"
        >{{(this.$session.get("brand") === 1 ? "Armani" : "Yves Saint Laurent")}}</v-toolbar-title>
      </v-flex>
    </v-toolbar>
    <v-navigation-drawer
      v-if="this.$session.exists()"
      style="position:fixed"
      v-model="drawer"
      absolute
      temporary
      light
    >
      <v-list class="pt-5 grey darken-2" dark/>
      <v-flex style="width:50px; margin:auto">
        <v-select :items="langs" v-model="currentLang" @change="switchLanguage()"/>
        <!-- Currently commented, Which permission should unlock it ? (an Armani Admin should not acces to YSL data) -->
        <!-- <v-select
          v-if="this.$session.get('jwt').permission === 3"
          :items="brands"
          item-text="name"
          item-value="value"
          v-model="selectedBrands"
          @change="editBrand();"
        /> -->
      </v-flex>
      <v-list class="pt-0" light>
        <v-divider/>
        <v-flex v-for="item in items" :key="item.title" @click="$router.push(item.path)">
          <v-list-item
            @click="$router.push(item.path)"
            v-if="item.requiredPermission <= $session.get('jwt').permission"
          >
            <v-list-item-avatar>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider v-if="item.requiredPermission <= $session.get('jwt').permission"/>
        </v-flex>
        <v-flex>
          <v-list-item @click="logout()">
            <v-list-item-avatar>
              <v-icon>logout</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-flex>
        <v-divider/>
      </v-list>
      <v-container class="text-center"></v-container>
    </v-navigation-drawer>
    </span>
</template>

<script>
import axios from 'axios'
import { urlDev, urlProd } from '../settings/settings.json'

const apiUrl = process.env.NODE_ENV === 'production' ? urlProd : urlDev

axios.defaults.baseURL = apiUrl

export default {
  data () {
    return {
      currentLang: 'en',
      componentKey: 0,
      selectedBrands: 1,
      langs: ['fr', 'en'],
      brands: [
        {
          name: 'Armani',
          value: 1
        },
        {
          name: 'YSL',
          value: 2
        }
      ],
      drawer: false,
      items: [
        {
          title: this.$t('global.concern'),
          icon: 'trending_up',
          path: '/concerns',
          requiredPermission: 2
        },
        {
          title: this.$t('global.questions'),
          icon: 'question_answer',
          path: '/questions',
          requiredPermission: 2
        },
        {
          title: this.$t('global.products'),
          icon: 'library_books',
          path: '/products',
          requiredPermission: 2
        },
        {
          title: this.$t('global.services'),
          icon: 'mood',
          path: '/services',
          requiredPermission: this.$session.get('brand') !== 1 ? 6 : 2
        },
        {
          title: this.$t('global.catalog'),
          icon: 'import_contacts',
          path: '/catalogs',
          requiredPermission: 1
        },
        {
          title: this.$t('users.add'),
          icon: 'person_add',
          path: '/user',
          requiredPermission: 2
        }
      ]
    }
  },
  methods: {
    logout: function () {
      let instance = axios.create({
        headers: { 'Authorization': 'Bearer ' + localStorage.token }
      });
      instance.get('/' + this.$session.get('brand') + '/logout')
      .then(() => {
        this.$session.destroy()
        localStorage.clear()
        this.componentKey++
        this.$router.push('/login')
      }).catch(console.log)
    },
    editBrand: function () {
      localStorage.brand = this.selectedBrands
      this.$session.set('brand', this.selectedBrands)
      this.componentKey++
    },
    switchLanguage () {
      this.$emit('reload', this.currentLang)
    }
  },
  mounted () {
    if (!this.$session.exists()) localStorage.clear()
    else if (!localStorage.isLogged) this.$session.destroy()
    else this.logged = true
  },
  created () {
    this.selectedBrands = localStorage.brand
    this.currentLang = this.$i18n.locale
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
}
.header__bar {
    width: 100%;
}
</style>
